export default {
  showOnlyAvailableApps: 'Pokaż tylko dostępne aplikacje',
};
